import type { CoachingPrompt } from "@/components/chat/CoachingSurface"

import type { CoachingContent } from "./conversation-state-builder"

/**
 * Converts goals from coaching content payload to interactive prompts
 * that can be used in the CoachingSurface component
 */
export function goalsToPrompts(
  content: CoachingContent | string | undefined,
): CoachingPrompt[] {
  // If content is a string or undefined, return empty array
  if (!content || typeof content === "string") {
    return []
  }

  // If goals exist in the content, map them to prompts
  if (content.goals && Array.isArray(content.goals)) {
    return content.goals.map((goal) => ({
      id: goal.id,
      label: goal.title,
      type: "default" as const,
      // You could add additional logic here to determine type or other properties
      // based on goal.id or other factors
    }))
  }

  return []
}

/**
 * Extracts the coaching question/instructions from coaching content
 */
export function getCoachingQuestion(
  content: CoachingContent | string | undefined,
): string | undefined {
  if (!content) return undefined

  if (typeof content === "string") {
    return content
  }

  // Combine title and instructions into a question format
  const parts: string[] = []

  if (content.title) {
    parts.push(content.title)
  }

  if (content.instructions && content.instructions.length > 0) {
    parts.push(...content.instructions)
  }

  return parts.length > 0 ? parts.join(" ") : undefined
}
